const SET_NEWSLETTER_LIST = 'SET_NEWSLETTER_LIST';
const SET_LOADING = 'SET_LOADING'


const combineConst = {
    SET_NEWSLETTER_LIST,
    SET_LOADING
};

export default combineConst;
